import React from 'react'
import { HelpModal } from '../../help/help-modal.component'

export const OpportunityProgramHelp = ({modalRef}) =>
  <HelpModal innerRef={modalRef} title='It impacts your financial aid'>
    Participants of College Discovery, SEEK and EOP have different academic requirements than regular TAP recipients.
  </HelpModal>